/**
 * data-dtf-reveal を持つ要素を、スクロールで一度だけフェードイン。
 * JS が動かない/無効でも要素は表示されるよう、初期の非表示状態は JS 側で付与する。
 * prefers-reduced-motion / IntersectionObserver 非対応では何もしない（＝常時表示）。
 */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  const els = document.querySelectorAll('[data-dtf-reveal]');
  if (!els.length) return;

  els.forEach((el) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(18px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  });

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          en.target.style.opacity = '1';
          en.target.style.transform = 'none';
          io.unobserve(en.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
  );
  els.forEach((el) => io.observe(el));
})();
